var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsmediaassets42(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #234492;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.43,20c4.92,2.46,9.84,4.92,14.77,7.38,4.3,2.15,8.6,4.3,12.9,6.44,.17,.08,.33,.17,.61,.33H21.19c.47-.24,.81-.41,1.15-.58,8.86-4.42,17.73-8.85,26.59-13.27,.19-.09,.37-.2,.56-.3,.31,0,.62,0,.94,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.01,77.77c.63-1.43,1.4-2.77,2.4-3.98,.47-.57,1.02-.83,1.77-.83,17.19,.01,34.38,.01,51.57,0,.72,0,1.32,.21,1.71,.81,.72,1.08,1.48,2.15,2.08,3.3,.72,1.4,.42,2.17-.93,2.93H21.3c-.6-.26-1.03-.69-1.29-1.29v-.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.01,37.7h59.97c-.33,.85-.53,1.68-.95,2.37-.85,1.37-1.81,2.67-2.76,3.98-.38,.52-.95,.69-1.6,.69-16.47,0-32.95,0-49.42,0-.73,0-1.26-.28-1.73-.8-1.58-1.76-2.8-3.73-3.51-6v-.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.65,48.29v21.13h-10.57v-21.13h10.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.29,48.27h10.57v21.13h-10.57v-21.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.74,48.27h10.45v21.13h-10.45v-21.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsmediaassets42);
export default __webpack_public_path__ + "static/media/UDS MEDIA ASSETS-42.c05b6d52022fd5b1daa24decdb3ae46f.svg";
export { ForwardRef as ReactComponent };